import Vue from 'vue'
import styled from 'vue-styled-components'
import Component from 'vue-class-component'

const pageHeaderWrap = styled.div`
    margin-top: 40px;
    width: 845px;
    text-align: center;
    width: 100%
`

const pageHeaderUpperText = styled.div`
    font-size: 38px;
    font-weight: 700;
    margin-top: 20px;
`

const pageHeaderBottomText = styled.div`
    font-size: 24px
    font-weight: 600
`

@Component
class PageHeader extends Vue.extend({
        props: {
            topText: {
                required: true,
                type: String
            },
            bottomText: {
                type: String
            }
        },
        components: {
            pageHeaderWrap,
            pageHeaderUpperText,
            pageHeaderBottomText
        }
    }) {
    render() {
        return (
            <pageHeaderWrap>
                <pageHeaderUpperText>
                    <slot name="icon"></slot>
                    <span>{this.$props.topText}</span>
                </pageHeaderUpperText>
                <pageHeaderBottomText>{this.$props.bottomText}</pageHeaderBottomText>
            </pageHeaderWrap>
        )
    }
}

const searchWrap = styled.div`
    width: 500px;
    display: block;
    height: 50px;
    margin: 50px auto 0;
    position: relative;
`
    
const searchString = styled.input`
    background: #fff;
    border: 1px solid #3b5998;
    box-shadow: inset 0px 0 3px #3b5998;
    min-width: 300px;
    height: 40px;
    padding: 0 50px 0 20px;
    border-radius: 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    ::placeholder {
        text-align: center;
        font-size: 16px !important;
        font-style: italic !important;
        color: #9e9e9e !important;
    }
`
    
@Component
class SearchBlock extends Vue.extend({
        components: {
            searchWrap,
            searchString
        }
    }) {
    render() {
        return (
            <searchWrap>
                <searchString></searchString>
            </searchWrap>
        )
    }
}

export {
    pageHeaderWrap,
    pageHeaderUpperText,
    pageHeaderBottomText,
    PageHeader,
    searchWrap,
    searchString,
    SearchBlock
}

const pageMixin = Vue.mixin({
    components: {
        pageHeaderWrap,
        PageHeader,
        pageHeaderUpperText,
        pageHeaderBottomText,
        searchWrap,
        searchString,
        SearchBlock
    }
})

export default pageMixin